import { useState } from "react";
import { useReveal } from "@/hooks/useReveal";

const FAQS = [
  {
    q: "Can we print our own brand on the sachet?",
    a: "Yes, starting with a 40-foot container. The design is adjusted to fit our die-cut template, and we verify compliance with the target market's labeling regulations prior to production.",
  },
  {
    q: "Can you go through our current distributor?",
    a: "That is usually the better route, and we prefer it. Name them in the form and we will approach them directly.",
  },
  {
    q: "Are samples free?",
    a: "Product samples are quoted separately. Custom-printed packaging samples come later, at the pilot run stage.",
  },
  {
    q: "How is this different from the brown sugar we already buy?",
    a: "Most brown sugar is refined white sugar with molasses added back. Ours is never separated in the first place, and it carries an organic certification you can show a customer or an auditor.",
  },
  {
    q: "Will the specification be the same every time?",
    a: "Yes. Moisture, granulometry and portion weight are held to an agreed specification and a certificate of analysis is issued per batch.",
  },
  {
    q: "How long does the first shipment take?",
    a: "Lead times depend on season and consolidation. Contact us for a current estimate from confirmed order to arrival at a South African port, plus your distributor's own inbound handling.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal text-center">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Questions we are always asked
          </h2>
        </div>

        <div className="mt-12 space-y-3">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className="border border-cream-dark/60 rounded-lg overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left"
                >
                  <span className="text-ink font-serif text-base md:text-lg font-semibold">
                    {item.q}
                  </span>
                  <i
                    className={`text-brown text-xl transition-transform duration-300 ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-5">
                    <p className="text-ink/70 text-[17px] leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}